import { useCallback } from 'react';
import cx from 'classnames';

import { FieldInput } from 'src/components/FieldInput';

import { useStyles } from './useStyles';

export const FieldMaxChars = ({ className, classes, value, onChange, disabled, error }) => {
  const styles = useStyles({ classes });

  const handleChange = useCallback(
    (event) => {
      if (!onChange) {
        return;
      }
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <FieldInput
      className={cx(className, styles.root)}
      classes={{ input: styles.input }}
      value={String(value || '')}
      onChange={handleChange}
      error={error}
      disabled={disabled}
      hideErrorMessage
    />
  );
};
